/* Nune homepage: oil carousel (arrows, drag, wheel, keys, autoplay, colour changes) and intro. */
(function () {
  'use strict';
  if (window.__nhmLoaded) return;
  window.__nhmLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initIntro(root) {
    var intro = root.querySelector('[data-nhm-intro]');
    if (!intro) return;
    var done = false;
    function finish() {
      if (done) return; done = true;
      document.documentElement.classList.remove('nhm-intro-on');
      intro.classList.add('is-leaving');
      setTimeout(function () { if (intro.parentNode) intro.parentNode.removeChild(intro); }, 450);
    }
    intro.addEventListener('animationend', function (e) { if (e.target === intro) finish(); });
    var skip = intro.querySelector('[data-nhm-skip]');
    if (skip) { skip.addEventListener('click', finish); skip.focus({ preventScroll: true }); }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') finish(); });
    setTimeout(finish, 4200); // safety net
  }

  function initHero(root) {
    if (root.__nhm) return; root.__nhm = true;
    initIntro(root);
    var stage = root.querySelector('[data-nhm-stage]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-nhm-slide]'));
    var n = slides.length;
    if (!stage || !n) return;
    var titleEl = root.querySelector('[data-nhm-title]');
    var subEl = root.querySelector('[data-nhm-sub]');
    var discover = root.querySelector('[data-nhm-discover]');
    var current = root.querySelector('[data-nhm-current]');
    var pauseBtn = root.querySelector('[data-nhm-pause]');
    var index = 0;
    var lastPos = slides.map(function (s) { return parseInt(s.getAttribute('data-pos'), 10) || 0; });

    function rel(i) {
      var d = i - index;
      if (d > n / 2) d -= n;
      if (d < -n / 2) d += n;
      if (n === 2 && d === -1) d = 1;
      return Math.max(-3, Math.min(3, d));
    }

    function render() {
      slides.forEach(function (s, i) {
        var pos = rel(i);
        if (Math.abs(pos - lastPos[i]) > 2) {
          // jumping across the screen: move without animating
          s.classList.add('is-jump');
          s.setAttribute('data-pos', pos);
          void s.offsetWidth;
          s.classList.remove('is-jump');
        } else {
          s.setAttribute('data-pos', pos);
        }
        lastPos[i] = pos;
        var link = s.querySelector('a');
        if (link) {
          if (pos === 0) { link.removeAttribute('tabindex'); link.removeAttribute('aria-hidden'); }
          else { link.setAttribute('tabindex', '-1'); link.setAttribute('aria-hidden', 'true'); }
        }
      });
      var a = slides[index];
      if (a.getAttribute('data-color')) root.style.setProperty('--blob', a.getAttribute('data-color'));
      if (a.getAttribute('data-ink')) root.style.setProperty('--ink-arc', a.getAttribute('data-ink'));
      if (titleEl) titleEl.textContent = a.getAttribute('data-title') || '';
      if (subEl) subEl.textContent = a.getAttribute('data-sub') || '';
      if (discover) discover.setAttribute('href', a.getAttribute('data-url') || discover.getAttribute('href'));
      if (current) current.textContent = pad(index + 1);
    }

    function go(i) { index = ((i % n) + n) % n; render(); restart(); }
    function next() { go(index + 1); }
    function prev() { go(index - 1); }

    // autoplay
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && n > 1;
    var paused = !autoplay || reduceMotion, hover = false, timer = null;
    if (pauseBtn) {
      pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      if (!autoplay) pauseBtn.style.visibility = 'hidden';
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        restart();
      });
    }
    function restart() {
      clearInterval(timer);
      if (paused || hover || n < 2) return;
      timer = setInterval(function () { if (!document.hidden) go(index + 1); }, speed);
    }
    stage.addEventListener('mouseenter', function () { hover = true; restart(); });
    stage.addEventListener('mouseleave', function () { hover = false; restart(); });
    root.addEventListener('focusin', function () { hover = true; restart(); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { hover = false; restart(); } });

    // arrows and keys
    var p = root.querySelector('[data-nhm-prev]'); var nx = root.querySelector('[data-nhm-next]');
    if (p) p.addEventListener('click', prev);
    if (nx) nx.addEventListener('click', next);
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
    });

    // click a side oil to bring it to the middle
    slides.forEach(function (s, i) {
      s.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); return; }
        if (i !== index) { e.preventDefault(); go(i); }
      });
    });

    // drag / swipe
    var startX = 0, startY = 0, dragging = false, moved = false, pid = null;
    stage.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      dragging = true; moved = false; pid = e.pointerId; startX = e.clientX; startY = e.clientY;
    });
    stage.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== pid) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (!moved && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) { moved = true; stage.classList.add('is-dragging'); }
    });
    function endDrag(e) {
      if (!dragging || e.pointerId !== pid) return;
      dragging = false; stage.classList.remove('is-dragging');
      var dx = e.clientX - startX;
      if (moved && Math.abs(dx) > 45) { dx < 0 ? next() : prev(); }
      setTimeout(function () { moved = false; }, 0);
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', function () { dragging = false; moved = false; stage.classList.remove('is-dragging'); });

    // wheel: steps through the oils while the carousel fills the screen; at the first or last oil the page scrolls on
    var wheelLock = 0, wheelSum = 0;
    root.addEventListener('wheel', function (e) {
      var dx = e.deltaX, dy = e.deltaY;
      var horizontal = Math.abs(dx) > Math.abs(dy);
      var d = horizontal ? dx : dy;
      if (!horizontal) {
        var top = root.getBoundingClientRect().top;
        if (Math.abs(top) > 60) return;
        if ((d > 0 && index >= n - 1) || (d < 0 && index <= 0)) return;
      }
      e.preventDefault();
      var now = Date.now();
      if (now < wheelLock) return;
      wheelSum += d;
      if (Math.abs(wheelSum) < 24) return;
      wheelSum > 0 ? next() : prev();
      wheelSum = 0; wheelLock = now + 650;
    }, { passive: false });

    // name tooltip that follows the mouse over an oil
    var tip = root.querySelector('[data-nhm-tip]');
    if (tip) {
      var tipText = tip.querySelector('[data-nhm-tip-text]');
      var tipSlide = null, tx = 0, ty = 0, cx = 0, cy = 0, lastX = 0, tilt = 0, traf = 0, placed = false;
      var tipTick = function () {
        if (reduceMotion) { cx = tx; cy = ty; } else { cx += (tx - cx) * .22; cy += (ty - cy) * .22; }
        tilt *= .86;
        tip.style.setProperty('--tx', cx.toFixed(1) + 'px');
        tip.style.setProperty('--ty', cy.toFixed(1) + 'px');
        tip.style.setProperty('--tr', (reduceMotion ? 0 : tilt).toFixed(2) + 'deg');
        traf = (Math.abs(tx - cx) + Math.abs(ty - cy) > .3 || Math.abs(tilt) > .05) ? requestAnimationFrame(tipTick) : 0;
      };
      var hideTip = function () { tipSlide = null; tip.classList.remove('is-on'); };
      stage.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || stage.classList.contains('is-dragging')) { hideTip(); return; }
        var s = e.target.closest && e.target.closest('[data-nhm-slide]');
        if (!s || s.getAttribute('data-pos') === '3' || s.getAttribute('data-pos') === '-3') { hideTip(); return; }
        if (s !== tipSlide) { tipSlide = s; tipText.textContent = s.getAttribute('data-title') || ''; }
        var r = stage.getBoundingClientRect();
        tx = e.clientX - r.left + 18; ty = e.clientY - r.top - 34;
        var w = tip.offsetWidth || 120;
        if (tx + w > r.width - 8) tx = e.clientX - r.left - w - 18; // keep it on screen
        if (!placed) { cx = tx; cy = ty; placed = true; }
        tilt = Math.max(-10, Math.min(10, tilt + (e.clientX - lastX) * .35));
        lastX = e.clientX;
        tip.classList.add('is-on');
        if (!traf) traf = requestAnimationFrame(tipTick);
      });
      stage.addEventListener('pointerleave', function () { hideTip(); placed = false; });
      stage.addEventListener('pointerdown', hideTip);
    }

    root.__nhmGo = function (i) { paused = true; if (pauseBtn) pauseBtn.setAttribute('aria-pressed', 'true'); go(i); };
    render();
    restart();
  }

  function initRange(root) {
    // nothing to wire for now: the strip scrolls natively and snaps on touch.
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-nhm-hero]').forEach(initHero);
    (scope || document).querySelectorAll('[data-nhm-range]').forEach(initRange);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-nhm-slide]');
    var hero = slide && slide.closest('[data-nhm-hero]');
    if (hero && hero.__nhmGo) hero.__nhmGo(parseInt(slide.getAttribute('data-index'), 10));
  });
})();
